import { h } from 'preact';
import { getColorFromMetaobjectMap } from '../../utils/helpers';
import styles from './BirdsnestColorSwatchGrid.module.scss';
function getColorStyle(option) {
    const meta = getColorFromMetaobjectMap(option.label);
    return { image: meta.plp_filter_image, color: meta.plp_hex };
}
export function BirdsnestColorSwatchGrid({ options, onChange }) {
    return (h("div", { class: styles.colorGrid }, options.map(option => {
        const { image, color } = getColorStyle(option);
        const background = image ? `url("${image}") center / cover` : color;
        return (h("button", { key: option.id, class: `${styles.colorItem} ${option.selected ? styles.selected : ''}`, onClick: () => onChange(option.id), type: "button" },
            h("span", { class: `${styles.colorSwatch} ${option.label.toLowerCase() === 'white' ? styles.whiteSwatch : ''}`, style: { background } }, option.selected && (h("svg", { class: styles.checkIcon, viewBox: "0 0 16 16", fill: "none" },
                h("path", { d: "M3 8l4 4 6-8", stroke: option.label.toLowerCase() === 'white' ? '#333' : '#fff', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))),
            h("span", { class: styles.colorLabel },
                option.label,
                " ",
                h("span", { class: styles.colorCount },
                    "(",
                    option.count,
                    ")"))));
    })));
}
